import { instance } from '@/api/instances'
import { addMemedLog } from '@/components/healthPlan/utils/addLog'
import { LogLevel } from '@/wrappers/logger'

const memedUrlStaging =
  'https://integrations.memed.com.br/modulos/plataforma.sinapse-prescricao/build/sinapse-prescricao.min.js'

const memedUrlProd = 'https://partners.memed.com.br/integration.js'

const MEMED_SCRIPT_URL =
  process.env.VUE_APP_ENV !== 'production' ? memedUrlStaging : memedUrlProd

const configPrescriptionFeatures = () => {
  window.MdHub?.command.send('plataforma.prescricao', 'setFeatureToggle', {
    deletePatient: false,
    removePatient: false,
    editPatient: false,
    historyPrescription: true,
    newPrescription: false,
    optionsPrescription: false,
    removePrescription: false,
    setPatientAllergy: false,
    autocompleteIndustrialized: true,
    autocompleteManipulated: true,
    autocompleteCompositions: true,
    autocompletePeripherals: false,
    copyMedicalRecords: false,
    buttonClose: true,
    newFormula: false,
    allowShareModal: false,
    guidesOnboarding: false,
    conclusionModalEdit: false,
    dropdownSync: false,
    showProtocol: false,
    showHelpMenu: false
  })
}

const configPrescriptionModule = store => {
  let hasConfiguredFeatures = false

  window.MdSinapsePrescricao?.event.add('core:moduleInit', module => {
    if (module.name !== 'plataforma.prescricao') return
    addMemedLog(LogLevel.INFO, 'Configuring memed features')
    configPrescriptionFeatures()
    hasConfiguredFeatures = true
  })

  window.MdSinapsePrescricao?.event.add('core:moduleHide', module => {
    if (module.moduleName !== 'plataforma.prescricao') return
    addMemedLog(LogLevel.INFO, 'Configuring prescription reset on module hide')
    window.MdHub.command.send('plataforma.prescricao', 'newPrescription')
  })

  const checkConfigurationDone = () => {
    if (hasConfiguredFeatures) {
      addMemedLog(LogLevel.INFO, 'Memed features configured')
      store.commit('initMemedResult', { error: false })
    } else setTimeout(() => checkConfigurationDone(), 500)
  }

  checkConfigurationDone()
}

export const addMemedScript = (token, store) => {
  if (hasMemedScript()) {
    addMemedLog(LogLevel.INFO, 'Already has memed script tag')
    store.commit('initMemedResult', { error: false })
    return
  }

  addMemedLog(LogLevel.INFO, 'Creating memed script tag')
  const script = document.createElement('script')
  script.setAttribute('type', 'text/javascript')
  script.setAttribute('data-token', token)
  script.src = MEMED_SCRIPT_URL
  script.setAttribute('data-color', '#e10096')
  script.onload = function () {
    addMemedLog(LogLevel.INFO, 'Memed script loaded')
    configPrescriptionModule(store)
  }
  addMemedLog(LogLevel.INFO, 'Created memed script tag')
  document.body.appendChild(script)
}

const unbindMemedEvents = () => window.MdHub?.server.unbindEvents()

const removeMemedObjects = () => {
  delete window.MdHub
  delete window.MdSinapsePrescricao
}

const removeMemedScript = () => {
  const scripts = Array.from(document.getElementsByTagName('script'))
  if (!scripts?.length) return
  scripts.forEach(script => {
    if (script.src.includes('memed.com.br'))
      script?.parentNode?.removeChild(script)
  })
}

const hasMemedScript = () => {
  const scripts = Array.from(document.getElementsByTagName('script'))
  if (!scripts?.length) return false
  return (
    !!scripts.find(script => script.src.includes('memed.com.br')) &&
    window.MdSinapsePrescricao?.event?.callbacks?.length
  )
}

export const destroyMemed = () => {
  addMemedLog(LogLevel.INFO, 'Removing memed script')

  unbindMemedEvents()
  removeMemedObjects()
  removeMemedScript()
}

export const getMemedToken = () => {
  return instance.get('prescriptions/physician_token')
}

export const getPersonData = personId => {
  return instance.get(`prescriptions/person/${personId}`)
}
